import React from 'react';
import { PriceFormatter } from '@components';
import styles from '../../KioskCheckout.module.scss';
import { useTranslation } from 'mycheck-core';
import { useOutletContext } from 'react-router-dom';
import { KioskOutletContext } from 'components/Kiosk/types';

export const KioskCheckoutTapBody = () => {
  const { t } = useTranslation();
  const { obfuscatedEmailReceipt, total } =
    useOutletContext<
      Pick<KioskOutletContext, 'obfuscatedEmailReceipt' | 'total'>
    >();
  return (
    <>
      {obfuscatedEmailReceipt && (
        <h3 className={styles.emailTitle}>
          {t('kiosk.kioskCheckoutBody.emailTitle')}&nbsp;
          {obfuscatedEmailReceipt}
        </h3>
      )}
      <h1 className={styles.title}>
        {t('kiosk.kioskCheckoutBody.title')}&nbsp;
        <PriceFormatter value={Number(total)} withoutSpace />
      </h1>
      <h2 className={styles.subtitle}>
        {t('kiosk.kioskCheckoutTapBody.subtitle')}
      </h2>
      <img
        alt="tapPayment"
        className={styles.tapImage}
        src="https://static-content.mycheckapp.com/pickupv2/updated_assets/tapPayment.jpg"
      />
    </>
  );
};
